import { render } from "./editTax.vue?vue&type=template&id=5f1f938a&scoped=true"
import script from "./editTax.vue?vue&type=script&lang=js"
export * from "./editTax.vue?vue&type=script&lang=js"

import "./editTax.vue?vue&type=style&index=0&id=5f1f938a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1f938a"]])

export default __exports__